import { Box } from '@mui/material';
import {
  AgronodAlert,
  AgronodButton,
  AgronodDialog,
  AgronodTypography,
} from '@agronod/mui-components';

interface Props {
  open: boolean;
  upptagen?: boolean;
  /** Serverns felmeddelande när godkännandet inte kunde sparas. */
  fel?: string | null;
  onClose: () => void;
  onGodkann: () => void;
}

/**
 * Godkännande innan en kund öppnas första gången (spec 6.1, AS-4231,
 * text enligt Karins underlag): ingen data om gårdar får sparas eller
 * exporteras utanför applikationen. Godkännandet sparas per användare och
 * kund i verifierings-DB och loggas – dialogen visas inte igen för samma
 * kund, men för varje ny kund. Avbryt stänger dialogen och lämnar
 * användaren kvar i kundvalet.
 */
export const DataskyddDialog = ({
  open,
  upptagen = false,
  fel = null,
  onClose,
  onGodkann,
}: Props) => (
  <AgronodDialog
    open={open}
    onClose={onClose}
    title="Bekräfta innan du fortsätter"
    maxWidth="sm"
    fullWidth
    actions={
      <>
        <AgronodButton variant="outlined" onClick={onClose} disabled={upptagen}>
          Avbryt
        </AgronodButton>
        <AgronodButton variant="contained" onClick={onGodkann} disabled={upptagen}>
          Jag godkänner
        </AgronodButton>
      </>
    }
  >
    <AgronodTypography variant="body1" sx={{ mb: fel ? 2 : 0 }}>
      För att använda verifieringsappen måste du godkänna att{' '}
      <Box component="strong" sx={{ fontWeight: 600 }}>
        ingen data om gårdar sparas eller exporteras utanför applikationen
      </Box>
      .
    </AgronodTypography>
    {fel && <AgronodAlert severity="error">{fel}</AgronodAlert>}
  </AgronodDialog>
);
